import { useState } from "react";
import { toast } from "sonner";
import { motion } from "framer-motion";

const WAITLIST_ENDPOINT =
  "https://script.google.com/macros/s/AKfycbwHnv4DY17yyvaiHONsvZQGw2GhFMwJr7DT03sWWqk18M954p3e_MlR098oHjDtBKCOsA/exec";

export default function WaitlistForm({
  placeholder = "Your email",
  buttonLabel = "Keep me posted",
  note,
  dark = false,
  testid = "waitlist-form",
}) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (status === "loading" || status === "done") return;
    setStatus("loading");
    try {
      const r = await fetch(WAITLIST_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify({ email }),
      });
      const data = await r.json();
      if (data.success || data.duplicate) {
        toast(data.message || (data.duplicate ? "You're already on the list." : "You're on the list."));
        setStatus("done");
      } else {
        toast.error(data.message || "Something went wrong. Please try again.");
        setStatus("idle");
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
      setStatus("idle");
    }
  };

  if (status === "done") {
    return (
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className={`font-serif serif-tactile italic text-xl md:text-2xl ${dark ? "text-paper" : "text-forest"}`}
        data-testid={`${testid}-success`}
      >
        You're on the list. Thank you for being here at the beginning.
      </motion.p>
    );
  }

  return (
    <div>
      <form
        onSubmit={submit}
        className="flex flex-col sm:flex-row items-stretch gap-3 sm:gap-4"
        data-testid={testid}
      >
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={placeholder}
          aria-label="Email address"
          className={`flex-1 bg-transparent border-b py-3.5 px-1 text-base outline-none transition-colors ${
            dark
              ? "border-paper/40 text-paper placeholder:text-paper/50 focus:border-paper"
              : "border-ink/30 text-ink placeholder:text-smoke/60 focus:border-forest"
          }`}
          data-testid={`${testid}-email-input`}
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className={`shrink-0 rounded-full text-xs uppercase tracking-[0.2em] px-8 py-4 transition-colors duration-300 disabled:opacity-50 ${
            dark ? "bg-paper text-ink hover:bg-brown hover:text-paper" : "bg-forest text-paper hover:bg-ink"
          }`}
          data-testid={`${testid}-submit-button`}
        >
          {status === "loading" ? "Sending…" : buttonLabel}
        </button>
      </form>
      {note && (
        <p className={`mt-4 text-xs leading-relaxed ${dark ? "text-paper/60" : "text-smoke/80"}`} data-testid={`${testid}-note`}>
          {note}
        </p>
      )}
    </div>
  );
}
